import { useState, useEffect } from "react";
import H2 from "@/atoms/text/H2";
import Image from "../atoms/Image";
import Label from "@/atoms/text/Label";
import Button from "@/atoms/Button";
import { isMobileScreen } from "@/utils/functions";
import { AestheticBg4, AestheticBg5 } from "@/atoms/Icons";

const EbookSection = ({
  title,
  bgColor,
  color,
  image,
  label,
  href,
  isImageOnLeft = false,
}) => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <section className={`aestheticBg ps-r pv-15-d pv-8 bc-${bgColor}`}>
      <div className="container fx fx--r-d fx--c fx--cv fx--sb-d">
        <article
          className={`ta-center ta-left-d mb-7 mb-reset-d ${
            isImageOnLeft ? "" : "content-wrapper w-50-d w-100 fx--order-2-d"
          }`}
        >
          <Label size="xxl" color="blue-200" className="bold mb-1">
            {label}
          </Label>
          <H2
            color={color}
            className="bold mb-8-d mb-7"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <Button
            href={href}
            size="md"
            variant="primary"
            rel="noopener noreferrer"
            target="_blank"
            className={`${isMobile ? "w-100" : ""}`}
          >
            Download now
          </Button>
        </article>
        <Image
          isBannerImg={image.isBannerImg}
          fileName={image.fileName}
          fileFormat={image.fileFormat}
          alt={image.altText}
          desktopWidth={image.desktopWidth}
          mobileWidth={image.mobileWidth}
          mobileHeight={image.mobileHeight}
          className={`fx--order-1-d ${isImageOnLeft ? "w-30-d" : ""} `}
        />
      </div>
      {!isMobile &&
        (isImageOnLeft ? (
          <AestheticBg5 className="aestheticBg-right" />
        ) : (
          <AestheticBg4 className="aestheticBg-right" />
        ))}
      <style jsx>{`
        @media (min-width: 1200px) {
          .content-wrapper {
            max-width: 540px;
          }
        }
      `}</style>
    </section>
  );
};

EbookSection.defaultProps = {
  bgColor: "grad-blue",
  color: "white",
  href: "#",
};
export default EbookSection;
